import RouterInteraction from './RouterInteraction';

export { RouterInteraction as default, RouterInteraction };
